var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDispositivosEfectivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-dispositivos-efectivo",
    transform: "translate(-0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1883",
    "data-name": "Rect\\xE1ngulo 1883",
    transform: "translate(0.333)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27352",
    "data-name": "Trazado 27352",
    d: "M7,15.628C7,12.5,7,10.941,8,9.971S10.62,9,13.849,9H24.122c3.229,0,4.843,0,5.846.971s1,2.533,1,5.657v3.314c0,3.124,0,4.686-1,5.657s-2.617.971-5.846.971H13.849c-3.229,0-4.843,0-5.846-.971s-1-2.533-1-5.657V15.628Z",
    transform: "translate(4.266 4.779)",
    fill: "none",
    stroke: "#777",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27353",
    "data-name": "Trazado 27353",
    d: "M18.849,15.314A3.426,3.426,0,1,1,15.424,12,3.37,3.37,0,0,1,18.849,15.314Z",
    transform: "translate(7.826 6.75)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_517",
    "data-name": "L\\xEDnea 517",
    y2: 31.25,
    transform: "translate(5.813 5.625)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDispositivosEfectivo);
export default __webpack_public_path__ + "static/media/icon-dispositivos-efectivo.15454f6482f98cf8ca761a1ebedc0358.svg";
export { ForwardRef as ReactComponent };